import { useTranslation } from 'react-i18next';
import { DateDropdownOptions } from '@/services/dictionaries/DateRangeValues';

export interface DateOptionsInterface {
    isBorderBottom?: boolean;
    value: number | string;
    label: string;
}

export const useDateDropdownOptions = (): DateOptionsInterface[] => {
    const { t } = useTranslation();

    return [
        {
            label: t('all'),
            value: DateDropdownOptions.All,
        },
        {
            label: t('last7days'),
            value: DateDropdownOptions.Last7days,
        },
        {
            label: t('last14days'),
            value: DateDropdownOptions.Last14days,
        },
        {
            label: t('last30days'),
            value: DateDropdownOptions.Last30days,
        },
        {
            label: t('last3months'),
            value: DateDropdownOptions.Last3months,
        },
        {
            label: t('last6months'),
            value: DateDropdownOptions.Last6months,
        },
        {
            label: t('lastyear'),
            value: DateDropdownOptions.Last12months,
        },
        {
            label: t('specificdaterange'),
            value: DateDropdownOptions.Calendar,
        },
    ];
};
export default useDateDropdownOptions;
